import moment from "moment";

var jwtDecode = require("jwt-decode");

class JWT {
  validateToken = token => {
    if (!token) return false;    
    let t = jwtDecode(token);
    if (t.nbf !== t.iat) return false;
    if (moment().unix() >= t.exp) return false;
    // 300 ts = 5 minutes
    if (t.exp - moment().unix() <= 300) this.refreshToken(token);
    return true;
  };
  parseToken = token => {
    if (!token) return false;
    let t = jwtDecode(token);
    if (t.nbf !== t.iat) return false;
    // if session expired then return false
    if (moment().unix() >= t.exp) return false;
    return t;
  };
  refreshToken = token => {
    if (!token) return false;    
    let t = jwtDecode(token);
    // 300 ts = 5 minutes
    if (t.exp - moment().unix() < 300) return true;
    return false;
  }
}

export default new JWT();
